import React from 'react';
import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';

import SavedSearchAlertCard from './SavedSearchAlertCard';
import useSearchMissTracking from './useSearchMissTracking';
import css from './NoSearchResultsMaybe.module.css';

const NoSearchResultsMaybe = props => {
  const {
    listingsAreLoaded,
    totalItems,
    location,
    resetAll,
    showCreateListingsLink,
    savedSearchAlertProps,
    searchMissProps,
  } = props;
  const intl = useIntl();
  const hasNoResult = listingsAreLoaded && totalItems === 0;
  const hasSearchParams = location.search?.length > 0;
  const recordSearchMissOutcome = useSearchMissTracking({
    authenticated: Boolean(savedSearchAlertProps?.currentUser?.id?.uuid),
    listingsAreLoaded,
    locale: intl.locale,
    location,
    routeListingType: searchMissProps?.routeListingType,
    totalItems,
  });

  const createListingLinkMaybe = showCreateListingsLink ? (
    <NamedLink
      className={css.createListingLink}
      name="NewListingPage"
      onClick={() => recordSearchMissOutcome('new_listing_clicked')}
    >
      <FormattedMessage id="SearchPage.createListing" />
    </NamedLink>
  ) : null;

  return hasNoResult ? (
    <div className={css.noSearchResults}>
      <FormattedMessage id="SearchPage.noResults" />
      {savedSearchAlertProps?.criteria?.length > 0 ? (
        <SavedSearchAlertCard
          key={location.search}
          {...savedSearchAlertProps}
          onSearchMissOutcome={recordSearchMissOutcome}
        />
      ) : null}

      <div className={css.btnContainer}>
        {hasSearchParams ? (
          <button
            className={css.resetAllFiltersButton}
            onClick={e => {
              recordSearchMissOutcome('reset_filters');
              resetAll(e);
            }}
          >
            <FormattedMessage id={'SearchPage.resetAllFilters'} />
          </button>
        ) : null}
        <p>{createListingLinkMaybe}</p>
      </div>
    </div>
  ) : null;
};

export default NoSearchResultsMaybe;
